// extracted by mini-css-extract-plugin
module.exports =  {"mapCanvas":"_32bbee5fda--mapCanvas--RKbYL"};